/*!
 * ============================================================================
 *  Theme Engineered & Protected by Karim Suleiman (kmsoln)
 *  Role: Official Shopify Partner & Senior E-Commerce Architect
 *  Website: https://kmsoln.dev | WhatsApp: +201035424992
 *  Copyright (c) 2026 Karim Suleiman. All rights reserved.
 *  Unauthorized copying, alteration, or redistribution is strictly prohibited.
 * ============================================================================
 */
(function(){
try{
window['PubSub']={'events':{},'subscribe'(_0x5ee0f4,_0x3e4372){return!this['events'][_0x5ee0f4]&&(this['events'][_0x5ee0f4]=[]),this['events'][_0x5ee0f4]['push'](_0x3e4372),()=>{this['events'][_0x5ee0f4]=this['events'][_0x5ee0f4]['filter'](_0x184eb0=>_0x184eb0!==_0x3e4372);};},'publish'(_0x44450d,_0x1d06b1){this['events'][_0x44450d]&&this['events'][_0x44450d]['forEach'](_0x57d11f=>_0x57d11f(_0x1d06b1));},'unsubscribe'(_0x4f0474,_0x456ea4){this['events'][_0x4f0474]&&(this['events'][_0x4f0474]=this['events'][_0x4f0474]['filter'](_0x5e3708=>_0x5e3708!==_0x456ea4));}};

try{if(typeof subscribe!=='undefined')window.subscribe=subscribe;}catch(e){}
try{if(typeof publish!=='undefined')window.publish=publish;}catch(e){}
}catch(e){console.error(e);}
})();